import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CreateEjeComponent } from '../create-eje/create-eje.component';
import { Handle } from 'src/app/handle';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GatewayService } from 'src/app/gateway.service';

@Component({
  selector: 'app-create-rol',
  templateUrl: './create-rol.component.html',
  styleUrls: ['./create-rol.component.scss']
})
export class CreateRolComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<CreateEjeComponent>, public Handle: Handle,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private gateway: GatewayService) { }
  operacion = 'createrol';
  idrol = '';
  idpais;

  ngOnInit() {
    if (this.data.operacion == 'Editar') {
      this.operacion = 'editrol';
      this.idrol = this.data.rol.IDROL;
      this.grupoVal.controls.NOMBRE.setValue(this.data.rol.NOMBRE);
      this.grupoVal.controls.DESCRIPCION.setValue(this.data.rol.DESCRIPCION);
    } else {
      this.idpais = this.data.rol.IDPAIS;
    }
  }

  save() {
    let ROL = {
      NOMBRE: this.grupoVal.controls.NOMBRE.value,
      DESCRIPCION: this.grupoVal.controls.DESCRIPCION.value,
      IDROL: this.idrol,
      IDPAIS: this.idpais

    }

    this.gateway.save(this.operacion, ROL).then((result) => {
      this.dialogRef.close();
    }
    ).catch(function (e) {
    });
  }

  onNoClick() {
    this.dialogRef.close();
  }

  grupoVal = new FormGroup({
    NOMBRE: new FormControl('', [Validators.compose([
      Validators.required, Validators.minLength(2), Validators.maxLength(30)
    ])]),
    DESCRIPCION: new FormControl('', Validators.compose([
      Validators.required, Validators.minLength(2), Validators.maxLength(100)
    ]))
  });

}
